<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Регионы</div>
        </div>
    </div>
    <table-element :actions="actions" :thead="thead" :tbody="tbody" @deleteItem="deleteRegion"></table-element>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
    <list-view></list-view>
</template>

<script>
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";
import ListView from "../../../elements/ListView";
import Region from "../../../models/Region";
import ChangePage from "../../../helpers/ChangePage";
import example from "../../../data/example";

export default {
    name: "RegionComponent",
    components: {
        TableElement,
        PaginationElement,
        ListView
    },
    props: {
        route_create_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            example,
            region: new Region({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            name: '',
            actions: [

            ],
            thead: [
                'Код',
                'Название',
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
        }
    },
    methods: {
        deleteRegion: function (params) {
            if (params.hasOwnProperty('id')) {
                let id = params.id;
                this.region.delete(id).then(this.loadTable);
            }
            else {
                console.log('Error: delete_item_undefined');
            }
        },
        loadTable: async function () {
            let response = await this.region.loadTable(this.page, this.limit, this.name);
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearchByName: async function () {
            if (this.name.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
